module.exports = __webpack_public_path__ + "img/table-bg.2d5ea0a9.png";